.bubble {
  padding: var(--dixa-size-spacer-200) var(--dixa-size-spacer-300);
  border-radius: var(--dixa-size-border-radius-100);
  word-break: break-word;

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }
}

.bubbleUser {
  background-color: var(--dixa-color-neutral-100);
  align-self: flex-end;
  max-width: 85%;
}

.bubbleAssistant {
  align-self: flex-start;
  max-width: 100%;
}
